import { WprBaseConverter } from '../WprBaseConverter';

/**
 * 3桁カンマコンバータ
 */
export class WprCommaConverter extends WprBaseConverter {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('3桁カンマ');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値変換処理
	 * @param value 値
	 * @returns 変換後の値
	 */
	public convert(value: any): string {
		try {
			let slist = String(value).split('.');
			let ret = String(slist[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
			if (slist.length > 1)
				ret += '.' + slist[1];
			return ret;
		}
		catch (ex) {
			return value;
		}
	}
	// --------------------------------------------------------------------------
}
